<!-- 文件列表组件 -->
<template>
    <div class="ele-file-list-group">
        <!-- 编辑弹窗 -->
        <el-dialog :title="title" :visible.sync="status" width="800px"
            :destroy-on-close="true" :lock-scroll="false" @close="closeDialog" :modal="false">
            <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="200px" class="demo-ruleForm">
                <el-form-item :label="'购买数量('+editForm.unit+'):'" prop="sort">
                   <el-input-number v-model="num" :precision="0" :step-strictly="true" :step="editForm.step" :max="editForm.max"></el-input-number>
                </el-form-item>
                <el-form-item label="金额:" prop="title">
                    <div>{{price}}元</div>
                </el-form-item>
                <el-form-item label="支付方式:" prop="title">
                    <el-radio v-model="pay_mode" label="2" border>微信支付</el-radio>
                    <el-radio v-model="pay_mode" label="3" border>支付宝支付</el-radio>
                </el-form-item>
                
            </el-form>
            <div slot="footer">
                <el-button @click="closeDialog">取消</el-button>
                <el-button type="primary" @click="save">支付</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "EleFileList",
        props: {
            status: { // 是否网格展示
                type: Boolean,
                default: true
            },
            mode:String,
            title:String
        },
        data() {
            return {
                editForm:{},
                editRules:{},
                num:1,
                price:0,
                pay_mode:'3',
            }
        },
        watch: {
            status: {
                handler(newName) {
                    if(newName){
                        this.payInfo();
                    }
                },
                immediate: true,
                deep: true
            },
            num:{
                handler(newName) {
                   this.price = parseFloat((newName/this.editForm.volume*this.editForm.price).toFixed(2))
                },
                immediate: true,
                deep: true
            }
        },
        computed: {
           
        },
        methods: {
            //查询支付信息
            payInfo(){
                this.$http.get('/mainsite/Storage/volumeBuyConf?mode=' + this.mode).then(res => {
                    if (res.data.code === 0) {
                        // this.editForm.user_ids = ;
                        this.showEdit = true;
                        setTimeout(() => {
                            this.editForm = res.data.data;
                            this.num = this.editForm.volume
                            this.price = this.editForm.price
                         }, 100);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            
            closeDialog(){
                 this.$emit('update:status',false)
            },
            save(){
                let data = {
                    volume:this.num,
                    id:this.editForm.id,
                    pay_mode:this.pay_mode
                }
                this.$http.post('/mainsite/Storage/volumeBuy',data).then(res => {
                    if (res.data.code === 0) {
                        window.open(res.data.data.url+'?out_pay_num='+res.data.data.out_pay_num, '_blank');
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            }
            
        }
    }
</script>

<style>
  
</style>
